export const SHOW_FAVORITES_NOTIFICATION = 'favorites:show'
